import { nanoid } from "@reduxjs/toolkit";
import React, { ChangeEventHandler, useEffect, useMemo, useState } from "react";
import ReactDatePicker from "react-datepicker";
import { useDispatch, useSelector } from "react-redux";
import Option from "../components/Option";
import { getOnlyUnique, SalesPerformanceList, SalesPerformanceType } from "../components/commonWidget";
import chartIcon from "../components/custom/assets/images/dashboard/chart_icon.svg";
import tableIcon from "../components/custom/assets/images/dashboard/table_icon.svg";
import FormInput2 from "../components/custom/components/FormInput2";
import { MultiSelect } from "../components/custom/components";
import {
  Tbody,
  Thead,
} from "../components/custom/components/TradeCategoryPerformanceTable";
import TransactionTable from "../components/custom/components/TransactionTable";
import { COLORS } from "../components/custom/constants";
import UserLayout from "../components/custom/layouts/UserLayout";
import { ToastTypes, useToast } from "../components/toast/ToastProvider";
import { defaultPortfolio, defaultTradeCategory, defaultTradeSubCategory, DropDownOption1, PAGE_SIZE } from "../config";
import api, { APIResponse, getAxiosRequestConfig } from "../config/api";
import {
  CSVdownload,
  handleDownloadPDF,
} from "../config/functions";
import { AuthUserType } from "../redux/actions/authUserActions";
import { BrandType } from "../redux/actions/brandActions";
import { BrandCompanyType } from "../redux/actions/brandCompanyActions";
import { PortfolioType } from "../redux/actions/portfolioActions";
import {
  OptionsTypes,
  addToSelectedOption,
} from "../redux/actions/selectedOptionsActions";
import { SiteType } from "../redux/actions/siteActions";
import { TradeCategoryType } from "../redux/actions/tradeCategoryActions";
import { TradeSubCategoryType } from "../redux/actions/tradeSubCategoryActions";
import { StoreState } from "../redux/store";

import { CatSubCatCompanyWithBrandRelationDataType } from "./TransactionBillWiseReport";
import Loader from "../components/custom/components/Loader";
import Modal from "../components/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWindowMaximize } from "@fortawesome/free-solid-svg-icons";
import { areaType } from "../redux/actions/areaActions";
import { outletType } from "../redux/actions/outletActions";
import { useLocation } from "react-router-dom";
import { UserLog } from "../config/common";
import { AvtMonthly,AvtYearly } from "../components/salesReports/salesATV"
import SingleSelect from "../components/custom/components/SingleSelect";
import SingleSelect1 from "../components/custom/components/SingleSelect1";

export interface DropDownOption {
  value: number;
  label: string;
  imgUrl: string;
}

export interface AvgTransactionValueRecord {
  brandid: number;
  total_receipts: number;
  total_sales: number;
  single_sku_percent: number | null;
  multiple_sku_percent: number | null;
  percent_top10: number;
  percent_81_90: number;
  percent_71_80: number;
  percent_61_70: number;
  percent_51_60: number;
  percent_41_50: number;
  percent_31_40: number;
  percent_21_30: number;
  percent_11_20: number;
  percent_least10: number;
}

export interface AvgTransactionValueReportType {
  portfolio: number;
  record: AvgTransactionValueRecord[];
  count?: number;
}

const SalesAvgTransactionValueReport: React.FC = () => {
  const toast = useToast();
  const dispatch = useDispatch();
const pageName = useLocation()
  const authUser = useSelector<StoreState, AuthUserType | null>(
    (state) => state?.authUser
  );
  const authUserToken = useSelector<StoreState, AuthUserType | null>(
    (state) => state?.authUser
  )?.["auth-token"]!;
  const config = getAxiosRequestConfig(authUserToken);

  const authUserSiteId = authUser?.siteId;

  const portfolioOption = useSelector<StoreState, PortfolioType[]>(
    (state) => state?.portfolio
  );
  const siteOption = useSelector<StoreState, SiteType[]>((state) => state?.site);
  const brandOption = useSelector<StoreState, BrandType[]>(
    (state) => state?.brand
  );
  const brandCompanyOption = useSelector<StoreState, BrandCompanyType[]>(
    (state) => state?.brandCompany
  );

  const selectedOption = useSelector<StoreState, OptionsTypes>(
    (state) => state?.selectedOption
  );
  const outletList = useSelector<StoreState, outletType[]>(
    (state) => state?.outlet
  );
  
  const localityOption = useSelector<StoreState, areaType[]>(
    (state) => state?.locality
  );

  const filteredBrand = brandOption?.filter((a) => {
    return brandCompanyOption?.some(
      (b) => b?.id?.toString() === a?.companyid?.toString() && b?.retailid !== null
    );
  });

  const port =
    authUser?.portfolioId !== undefined && authUser?.portfolioId !== null
      ? authUser?.portfolioId?.split(",")
      : [];

  let portfolioData = port
    ?.map((pe) => {
      return portfolioOption?.filter(
        (f) => f?.id?.toString() === pe?.toString()
      );
    })
    ?.flat(1);

  const pname = portfolioData[0]?.name;

  const st =
    authUser?.siteId !== undefined && authUser?.siteId !== null
      ? authUser?.siteId?.split(",")
      : [];

  let siteData = st
    ?.map((pe) => {
      return siteOption?.filter((f) => f?.id?.toString() === pe?.toString());
    })
    ?.flat(1);
  const categoryOption = useSelector<StoreState, TradeCategoryType[]>(
    (state) => state?.tradeCategory
  );
  const subCategoryOption = useSelector<StoreState, TradeSubCategoryType[]>(
    (state) => state?.tradeSubCategory
  );

  const [
    catSubCatCompanyWithBrandRelationData,
    setCatSubCatCompanyWithBrandRelationData,
  ] = useState<CatSubCatCompanyWithBrandRelationDataType[]>([]);


  const [fileLoader, setFileLoader] = useState<boolean>(false);

  const [valueIn, setValueIn] = useState<string>("");

  const [portfolios, setPortfolios] = useState<string>("");
  const [sites, setSites] = useState<string>("");
  const [brands, setBrands] = useState<string>("");

  // const [location, setLocation] = useState<string>("");
  const [locations, setLocations] = useState<DropDownOption[]>([]);
  const [categories, setCategories] = useState<string>("");
  const [subCategories, setSubCategories] = useState<string>("");
  const [selection, setSelection] = useState<SalesPerformanceType>(
    SalesPerformanceList?.MONTHLY
  );


  const [AvgTransactionValueData, setAvgTransactionValueData] = useState<
    AvgTransactionValueReportType[]
  >([]);
  const [yearlyAvgTransactionValueData, setYearlyAvgTransactionValueData] =
    useState<AvgTransactionValueReportType[]>([]);
  const [yearAndMonth, setYearAndMonth] = useState<Date>(new Date());
  const [year, setYear] = useState<Date>(new Date());
  const month = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];

  const limit = PAGE_SIZE;
  const [offset, setOffset] = useState<number>(0);
  const [range, setRange] = useState<number[]>([]);
  const [length, setLength] = useState<number>(50);

  const [loader, setLoader] = useState<boolean>(false);
  const [pag, setPag] = useState<boolean>(false);

  const [selectedRows, setSelectedRows] = useState<string[]>([]);
  const [condition,setCondition] = useState<boolean>(false)

  const [showModal, setShowModal] = useState<boolean>(false);
  const [isButtonVisible, setButtonVisible] = useState(false);
  const [disableLocality, setDisableLocality] = useState<boolean>(false);

  const [portfoliosOption, setPortfoliosOption] = useState<DropDownOption1>(defaultPortfolio);
  const [categoriesOption, setCategoriesOption] = useState<DropDownOption1>(defaultTradeCategory);
  const [subCategoriesOption, setSubcategoriesOption] = useState<DropDownOption1>(defaultTradeSubCategory);

  const [portfolioDrop, setPortfolioDrop] = useState<DropDownOption[]>([]);
  const [catDrop,setCatDrop] = useState<DropDownOption[]>([])
  const [subcatDrop,setSubcatDrop] = useState<DropDownOption[]>([])

  const showExpandModalHandler = () => {
    setShowModal(true)
  };

  const handleSelectedRowsChange = (selectedRows: string[]) => {
    setSelectedRows(selectedRows);
  };

  const locality = useMemo<string[]>(() => {
    return locations?.map((p) => {
      return p?.label;
    });
  }, [locations]);
  const SiteFilteredByPortfolio = useMemo<SiteType[]>(() => {
    if (portfolios !== "") {
      return siteData?.filter((s) => {
        return s?.pfid?.toString() === portfolios?.toString();
      });
    } else return [];
  }, [portfolios, siteData]);

  const subCategoryFilteredByCategory = useMemo<TradeSubCategoryType[]>(() => {
    if (categories !== "") {
      return subCategoryOption?.filter((sc) => {
        return sc?.catid?.toString() === categories?.toString();
      });
    } else return subCategoryOption;
  }, [categories, subCategoryOption]);

  const handleOff = (conditionVal: boolean) => {
    setCondition(conditionVal);
  };

  const monthlyHandler = () => {
    setSelection(SalesPerformanceList?.MONTHLY);
    setPag(false);
  };

  const yearlyHandler = () => {
    setSelection(SalesPerformanceList?.YEARLY);
    setPag(false);
  };

  const handlePortfolioDrop = (selected: any) => {
    if(fileLoader===false){
    if(selected.length>0){
      const selectedPortfolio = selected as DropDownOption[];
      if(selectedPortfolio[0].value!==null&&selectedPortfolio[0].value!==0){
        setPortfolioDrop(selectedPortfolio)
        setPortfolios(selectedPortfolio[0]?.value?.toString())
        const data = { ...selectedOption, portfolio: selectedPortfolio[0]?.value?.toString() };
        dispatch(addToSelectedOption(data));
        setOffset(0);
        setPag(false);
      }
    }
  }
  };

  const handleClearPortfolio = () =>{
    let pid =portfolioData[0] && portfolioData[0]?.id? portfolioData[0].id?.toString(): "";
    setPortfolios(selectedOption.portfolio ? selectedOption.portfolio : pid);
    const b = portfolioOption.filter((a)=>a?.id?.toString()===pid?.toString())
    if (b?.length > 0 && b[0]?.id !== undefined) {
      const val: DropDownOption = {
        value: b[0]?.id, 
        label: b[0]?.name,
        imgUrl: b[0]?.logourl, 
      };
      setPortfolioDrop([val]);

      if(fileLoader===false){
      setLocations([]);
      const data = { ...selectedOption, portfolio: b[0]?.id?.toString(),location:'',locations:[]};
      dispatch(addToSelectedOption(data));
      setOffset(0);
      setPag(false);
    }
  }
  }


  // const handleLocationChange: ChangeEventHandler<HTMLInputElement> = (e) => {
  //   if (fileLoader === false) {
  //     setLocation(e?.target?.value);
  //     const data = { ...selectedOption, location: e?.target?.value };
  //     dispatch(addToSelectedOption(data));
  //     setOffset(0);
  //     setPag(false);
  //   }
  // };

  const handleCatDrop = (selected: any) => {
    if(fileLoader===false){
    if(selected.length>0){
      const selectedCat = selected as DropDownOption[];
      if(selectedCat[0].value!==null&&selectedCat[0].value!==0){
        setCatDrop(selectedCat)
        setCategories(selectedCat[0]?.value?.toString())
        setSubcatDrop([])
        setSubCategories('')
        const data = {
          ...selectedOption,
          category: selectedCat[0]?.value?.toString(),
          subCategory: "",
          brand: "",
          brands:[]
        };
        dispatch(addToSelectedOption(data));
        setOffset(0);
        setPag(false);
      }
    }
  }
  };
  
  const handleClearCat = () =>{
    if(fileLoader===true){
      setCategories(categories ? categories : '');
      const b = categoryOption.filter((a)=>a?.id?.toString()===categories?.toString())
      if (b?.length > 0 && b[0]?.id !== undefined) {
        const val: DropDownOption = {
          value: b[0]?.id, 
          label: b[0]?.name,
          imgUrl:'', 
        };
        setCatDrop([val]);
     }
     else{
      setCatDrop([])
   }
    }
   
     if(fileLoader===false){
      setCatDrop([])
      setCategories('')
      setSubcatDrop([])
        setSubCategories('')
       const data = { ...selectedOption,
        category: '',
        subCategory: "",
        brand: "",
      brands:[]};
       dispatch(addToSelectedOption(data));
       setOffset(0);
       setPag(false);
     }
  }

  const handleSubcatDrop = (selected: any) => {
    if(fileLoader===false){
    if(selected.length>0){
      const selectedSubcat = selected as DropDownOption[];
      if(selectedSubcat[0].value!==null&&selectedSubcat[0].value!==0){
        setSubcatDrop(selectedSubcat)
        setSubCategories(selectedSubcat[0]?.value?.toString())
        const data = { ...selectedOption,
          subCategory: selectedSubcat[0]?.value?.toString(),
          brand: "",};
         dispatch(addToSelectedOption(data));
         setOffset(0);
         setPag(false);
      }
    }
  }
  };
  
  const handleClearSubcat = () =>{
    if(fileLoader===true){
      setSubCategories(subCategories ? subCategories : '');
      const b = subCategoryOption.filter((a)=>a?.id?.toString()===subCategories?.toString())
      if (b?.length > 0 && b[0]?.id !== undefined) {
        const val: DropDownOption = {
          value: b[0]?.id, 
          label: b[0]?.name,
          imgUrl:'', 
        };
        setSubcatDrop([val]);
     }else{
      setSubcatDrop([])
   }
    }
   
     if(fileLoader===false){
      setSubcatDrop([])
        setSubCategories('')
       const data = { ...selectedOption,
        subCategory: "",
        brand: "",
      brands:[]};
       dispatch(addToSelectedOption(data));
       setOffset(0);
       setPag(false);
     }
  }
  // const handleCompanyChange: ChangeEventHandler<HTMLInputElement> = (e) => {
  //   if (fileLoader === false) {
  //     setBrands("");
  //     const data = { ...selectedOption, company: e?.target?.value, brand: "" };
  //     dispatch(addToSelectedOption(data));
  //     setOffset(0);
  //     setPag(false);
  //   }
  // };


  const portFilter = portfolioOption?.filter((a)=>a?.id?.toString()===portfolios?.toString())
  const catFilter = categoryOption?.filter((a)=>a?.id?.toString()===categories?.toString())
  const subcatFilter = subCategoryOption?.filter((a)=>a?.id?.toString()===subCategories?.toString())
  const brandFilter = brandOption?.filter((a)=>a?.id?.toString()===brands?.toString())
  let localitiesName = ''
  if(locations?.length>0){
    let locNameArr: string[] = [];
    locations?.map((s) => {
      locNameArr?.push(s?.label);
    });
    localitiesName = locNameArr?.join(", ");
  }



  const combinedValues = [
    ...portFilter?.map(a => `Portfolio: ${a?.name}`),           
    ...catFilter?.map(c=> `Trade Category: ${c?.name}`),
    ...subcatFilter?.map(d=> `Trade Sub Category: ${d?.name}`),
    ...brandFilter?.map(f=> `Brand: ${f?.name}`),  
    localitiesName!== '' ? `Locality: ${localitiesName}` : '' ,   
    selection===SalesPerformanceList?.MONTHLY&&yearAndMonth!==null?`Year: ${yearAndMonth?.getFullYear()}, Month: ${yearAndMonth?.getMonth()+1}`:'',
    selection===SalesPerformanceList?.YEARLY?`Period: ${year?.getFullYear()}`:''
  ]
  ?.filter(name => name && name?.trim() !== '') 
  ?.join(', ');  
  

  const getSubtitle = useMemo<string>(() => {
    let subtxt = `\u3010Company\u3011: ${pname}`;
    if (locations?.length > 0) {
      let locNameArr: string[] = [];
      locations?.map((s) => {
          locNameArr?.push(s?.label);
      });
      let localities = locNameArr?.join(", ");
      subtxt += ` \u3010Locality\u3011: ${localities}`;
    }
    if (categories?.length > 0 && categories !== undefined) {
      const categoryIndex = categoryOption?.findIndex(
          (a) => a?.id?.toString() === categories?.toString()
      );
      const categoryName =
          categoryOption[categoryIndex]?.name;
      subtxt += ` \n\u3010TradeCategory\u3011: ${categoryName}`;
    }
    if (subCategories?.length > 0) {
      const subcategoryIndex = subCategoryOption?.findIndex( (a) => a?.id?.toString() === subCategories?.toString() );
      const subcatName = subCategoryOption[subcategoryIndex]?.name;
      subtxt += ` \u3010TradeSubcategory\u3011: ${subcatName}`;
    }
    return subtxt;
  }, [pname, locations, categories, subCategories, categoryOption, subCategoryOption]);


  const tHead = useMemo<Thead[]>(() => {
    var theadArray = [
      { id: "Brand Name", children: "Brand Name", text: "Brand Name" },
      {
        id: "Total Receipts",
        children: "Total Receipts",
        text: "Total Receipts",
      },
      { id: "Total Sales", children: "Total Sales", text: "Total Sales" },
      {
        id: "Single SKU (%)",
        children: "Single SKU (%)",
        text: "Single SKU (%)",
      },
      {
        id: "Multiple SKU (%)",
        children: "Multiple SKU (%)",
        text: "Multiple SKU (%)",
      },
      { id: "Top 10%", children: "Top 10%", text: "Top 10%" },
      { id: "81-90%", children: "81-90%", text: "81-90%" },
      { id: "71-80%", children: "71-80%", text: "71-80%" },
      { id: "61-70%", children: "61-70%", text: "61-70%" },
      { id: "51-60%", children: "51-60%", text: "51-60%" },
      { id: "41-50%", children: "41-50%", text: "41-50%" },
      { id: "31-40%", children: "31-40%", text: "31-40%" },
      { id: "21-30%", children: "21-30%", text: "21-30%" },
      { id: "11-20%", children: "11-20%", text: "11-20%" },
      { id: "Least 10%", children: "Least 10%", text: "Least 10%" },
    ];
    return theadArray;
  }, []);

  const tHead1 = useMemo<Thead[]>(() => {
    var theadArray = [
      { id: "Brand Name", children: "Brand Name", text: "Brand Name" },
      {
        id: "Total Receipts",
        children: "Total Receipts",
        text: "Total Receipts",
      },
      { id: "Total Sales", children: "Total Sales", text: "Total Sales" },
      {
        id: "Single SKU (%)",
        children: "Single SKU (%)",
        text: "Single SKU (%)",
      },
      {
        id: "Multiple SKU (%)",
        children: "Multiple SKU (%)",
        text: "Multiple SKU (%)",
      },
      { id: "Top 10%", children: "Top 10%", text: "Top 10%" },
      { id: "81-90%", children: "81-90%", text: "81-90%" },
      { id: "71-80%", children: "71-80%", text: "71-80%" },
      { id: "61-70%", children: "61-70%", text: "61-70%" },
      { id: "51-60%", children: "51-60%", text: "51-60%" },
      { id: "41-50%", children: "41-50%", text: "41-50%" },
      { id: "31-40%", children: "31-40%", text: "31-40%" },
      { id: "21-30%", children: "21-30%", text: "21-30%" },
      { id: "11-20%", children: "11-20%", text: "11-20%" },
      { id: "Least 10%", children: "Least 10%", text: "Least 10%" },
    ];
    return theadArray;
  }, []);

  const fetchDataForDownload = async () => {
    let error = false;
    if (portfolios === "") {
      toast("Select Portfolio", ToastTypes?.ERROR);
      error = true;
    }
    if (selection === SalesPerformanceList?.YEARLY) {
      if (
        year === null ||
        (year !== null && year?.getFullYear()?.toString() === "")
      ) {
        toast("Select year", ToastTypes?.ERROR);
        error = true;
      }
    }
    if (selection === SalesPerformanceList?.MONTHLY) {
      if (
        yearAndMonth === null ||
        (yearAndMonth !== null &&
          yearAndMonth?.getFullYear()?.toString() === "" &&
          yearAndMonth?.getMonth()?.toString() === "")
      ) {
        toast("Select month and year", ToastTypes?.ERROR);
        error = true;
      }
    }

    const yr = yearAndMonth?.getFullYear();
    const mon = month[yearAndMonth?.getMonth()];

    var MgetData = {
      portfolio: portfolio,
      site: site,
      locality: locality,
      tradeCategory: category,
      tradeSubCategory: subCategory,
      brand: brand,
      year: yr,
      month: mon,
      limit: limit?.toString(),
      offset: offset?.toString(),
    };
    // } else {
    var YgetData = {
      portfolio: portfolio,
      site: site,
      locality: locality,
      tradeCategory: category,
      tradeSubCategory: subCategory,
      brand: brand,
      year: year?.getFullYear(),
      // month: mon,
      limit: limit?.toString(),
      offset: offset?.toString(),
    };

    if (error === false && MgetData !== undefined) {
      if (selection === SalesPerformanceList?.MONTHLY) {
        const response = await api.post<
          APIResponse<{ records: AvgTransactionValueReportType[] }>
        >(`kpi/sales/monthlyAvgTransactionValue`, MgetData, config);

        if (response?.status === 200 && response?.data?.data) {
          return response?.data?.data?.records;
        }
      } else if (selection === SalesPerformanceList?.YEARLY) {
        const response = await api.post<
          APIResponse<{ records: AvgTransactionValueReportType[] }>
        >(`kpi/sales/yearlyAvgTransactionValue`, YgetData, config);

        if (response?.status === 200 && response?.data?.data) {
          return response?.data?.data?.records;
        }
      }
    }

    return [];
  };

  const getDownloadData = (Data: AvgTransactionValueReportType[]) => {
    var tableHead: Thead[] = tHead;
    var tableBody: Tbody[][] = [];

    Data?.forEach((d, i) => {
      d?.record?.forEach((item) => {
        const brand = filteredBrand?.find(
          (f) => f?.id?.toString() === item?.brandid?.toString()
        );

        var tBody: Tbody[] = [];
        tBody?.push(
          {
            id: nanoid(),
            theadId: "Brand Name",
            children: brand?.name,
            text: brand?.name?.toString(),
          },
          {
            id: nanoid(),
            theadId: "Total Receipts",
            children: item?.total_receipts,
            text: item?.total_receipts?.toString(),
          },
          {
            id: nanoid(),
            theadId: "Total Sales",
            children: item?.total_sales,
            text: item?.total_sales?.toString(),
          },
          {
            id: nanoid(),
            theadId: "Single SKU (%)",
            children: item?.single_sku_percent,
            text: item?.single_sku_percent?.toString(),
          },
          {
            id: nanoid(),
            theadId: "Multiple SKU (%)",
            children: item?.multiple_sku_percent,
            text: item?.multiple_sku_percent?.toString(),
          },
          {
            id: nanoid(),
            theadId: "Top 10%",
            children: item?.percent_top10,
            text: item?.percent_top10?.toString(),
          },
          {
            id: nanoid(),
            theadId: "81-90%",
            children: item?.percent_81_90,
            text: item?.percent_81_90?.toString(),
          },
          {
            id: nanoid(),
            theadId: "71-80%",
            children: item?.percent_71_80,
            text: item?.percent_71_80?.toString(),
          },
          {
            id: nanoid(),
            theadId: "61-70%",
            children: item?.percent_61_70,
            text: item?.percent_61_70?.toString(),
          },
          {
            id: nanoid(),
            theadId: "51-60%",
            children: item?.percent_51_60,
            text: item?.percent_51_60?.toString(),
          },
          {
            id: nanoid(),
            theadId: "41-50%",
            children: item?.percent_41_50,
            text: item?.percent_41_50?.toString(),
          },
          {
            id: nanoid(),
            theadId: "31-40%",
            children: item?.percent_31_40,
            text: item?.percent_31_40?.toString(),
          },
          {
            id: nanoid(),
            theadId: "21-30%",
            children: item?.percent_21_30,
            text: item?.percent_21_30?.toString(),
          },
          {
            id: nanoid(),
            theadId: "11-20%",
            children: item?.percent_11_20,
            text: item?.percent_11_20?.toString(),
          },
          {
            id: nanoid(),
            theadId: "Least 10%",
            children: item?.percent_least10,
            text: item?.percent_least10?.toString(),
          }
        );
        tableBody?.push(tBody);
      });
    });
    return { tbody: tableBody, thead: tableHead };
  };
  useEffect(()=>{    
    if(selectedOption?.isOutletUser){
      setDisableLocality(true);
    }
    else{
      setDisableLocality(false);
    }
  },[authUser, outletList,selectedOption]);

  useEffect(() => {
    if (selection === SalesPerformanceList?.MONTHLY) {
      const header = tHead
        ?.map((a) => a?.text)
        ?.filter(
          (id): id is string => typeof id === "string" && id !== undefined
        );
      setSelectedRows(header);
    }
    if (selection === SalesPerformanceList?.YEARLY) {
      const header = tHead1
        ?.map((a) => a?.text)
        ?.filter(
          (id): id is string => typeof id === "string" && id !== undefined
        );
      setSelectedRows(header);
    }
  }, [selection]);

  const handleApply = () => {
    let error = false;
    if (portfolios === "") {
      toast("Select Portfolio", ToastTypes?.ERROR);
      error = true;
    }
    if (selection === SalesPerformanceList?.YEARLY) {
      if (
        year === null ||
        (year !== null && year?.getFullYear()?.toString() === "")
      ) {
        toast("Select year", ToastTypes?.ERROR);
        error = true;
      }
    }
    if (selection === SalesPerformanceList?.MONTHLY) {
      if (
        yearAndMonth === null ||
        (yearAndMonth !== null &&
          yearAndMonth?.getFullYear()?.toString() === "" &&
          yearAndMonth?.getMonth()?.toString() === "")
      ) {
        toast("Select month and year", ToastTypes?.ERROR);
        error = true;
      }
    }


    // if (selection === SalesPerformanceList?.MONTHLY) {
    const yr = yearAndMonth?.getFullYear();
    const mon = month[yearAndMonth?.getMonth()];

    var MgetData = {
      portfolio: portfolio,
      site: site,
      locality: locality,
      tradeCategory: category,
      tradeSubCategory: subCategory,
      brand: brand,
      year: yr,
      month: mon,
      limit: limit?.toString(),
      offset: offset?.toString()==='NaN'||offset===undefined?'0':offset?.toString(),
      authUserRole: authUser?.roleId ? authUser?.roleId : "",
    };
    // } else {
    var YgetData = {
      portfolio: portfolio,
      site: site,
      locality: locality,
      tradeCategory: category,
      tradeSubCategory: subCategory,
      brand: brand,
      year: year?.getFullYear(),
      // month: mon,
      limit: limit?.toString(),
      offset: offset?.toString()==='NaN'||offset===undefined?'0':offset?.toString(),
      authUserRole: authUser?.roleId ? authUser?.roleId : "",
    };
    // }

    if (
      error === false &&
      MgetData !== undefined &&
      YgetData?.limit !== "" &&
      YgetData?.offset !== ""
    ) {
      if (pag === false) {
        setLoader(true);
      }
      if (selection === SalesPerformanceList?.MONTHLY) {
        api
          .post<APIResponse<{ records: AvgTransactionValueReportType[] }>>(
            `kpi/sales/monthlyAvgTransactionValue`,
            MgetData,
            config
          )
          .then((response) => {
            if (response?.status === 200 && response?.data?.data) {
              const result = response?.data?.data?.records;
              setLoader(false);
              setPag(true);
              setAvgTransactionValueData(result);
              setCondition(false)
              if(authUser){
                const logProps1 = {
                  action: 'Apply',
                  event: `${pageName?.pathname?.replace("\\", " ")} page | Filters - ${combinedValues} | Apply Clicked | Data Status: ${result?.[0]?.count && result[0]?.count > 0 ? 'Success' : 'Empty'}`
                };
                UserLog(logProps1)
              }
              // calculateRange(limit)
            }
          })
          .catch((error) => {});
      } else if (selection === SalesPerformanceList?.YEARLY) {
        if (pag === false) {
          setLoader(true);
        }
        api
          .post<APIResponse<{ records: AvgTransactionValueReportType[] }>>(
            `kpi/sales/yearlyAvgTransactionValue`,
            YgetData,
            config
          )
          .then((response) => {
            if (response?.status === 200 && response?.data?.data) {
              const result = response?.data?.data?.records;
              setLoader(false);
              setPag(true);
              setYearlyAvgTransactionValueData(result);
              setCondition(false)
              if(authUser){
                const logProps1 = {
                  action: 'Apply',
                  event: `${pageName?.pathname?.replace("\\", " ")} page | Filters - ${combinedValues} | Apply Clicked | Data Status: ${result?.[0]?.count && result[0]?.count > 0 ? 'Success' : 'Empty'}`
                };
                UserLog(logProps1)
              }
              // calculateRange(limit)
            }
          })
          .catch((error) => {});
      }
    } else {
      setAvgTransactionValueData([]);
      setYearlyAvgTransactionValueData([]);
      setLoader(false);
      setPag(true);
      setCondition(false)
    }
  };

  useEffect(() => {
    if (
      portfolios !== "" &&
      fileLoader === false &&
      (selection === SalesPerformanceList?.MONTHLY ||
        SalesPerformanceList?.YEARLY)
    )
      handleApply();
  }, [portfolios, selection]);

  const handleCsvDownload = async () => {
    setFileLoader(true);
    const csvData = await fetchDataForDownload();
    if (csvData[0]?.record?.length !== 0 && csvData[0]?.record !== undefined) {
      const d = { ...getDownloadData(csvData) };

      const filteredHead = d?.thead
        ?.map((a) => {
          const foundObject = selectedRows
            ?.map((b) => {
              if (a?.text?.toString() === b?.toString()) {
                return a;
              }
            })
            ?.find((obj) => obj !== undefined);

          if (foundObject !== undefined) {
            return foundObject;
          }
        })
        ?.filter((obj) => obj !== undefined);
      const csvHead = filteredHead;
      const csvBody = d?.tbody;

      const head = [csvHead?.map((h) => h?.text || "") || []];
      const body =
        csvBody?.map((tr, i) => {
          return (
            csvHead?.map((th, j) => {
              const col = tr?.find((r) => r?.theadId === th?.id);
              return col?.text || "";
            }) || []
          );
        }) || [];

      const rows = [...head, ...body];
      const props = {
        rows: rows,
        fileName: "Avg Transaction Value Report",
      };
      CSVdownload(props);
      setFileLoader(false);
      if(authUser){
        const logProps1 = {
          action: 'Csv',
          event: `${pageName?.pathname?.replace("\\", " ")} page | Filters - ${combinedValues} | Csv Clicked | Export Status: Success | Data Status: Success`
        };
        UserLog(logProps1)
      }
    } else {
      setFileLoader(false);
      if(authUser){
        const logProps1 = {
          action: 'Csv',
          event: `${pageName?.pathname?.replace("\\", " ")} page | Filters - ${combinedValues} | Csv Clicked | Export Status: Success | Data Status: Empty`
        };
        UserLog(logProps1)
      }
    }
    setFileLoader(false);
  };

  const handlePdfDownload = async () => {
    setFileLoader(true);
    const pdfData = await fetchDataForDownload();
    if (
      pdfData[0]?.record?.length !== 0 &&
      pdfData[0]?.record?.length !== undefined
    ) {
      const d = { ...getDownloadData(pdfData) };

      const filteredHead = d?.thead
        ?.map((a) => {
          const foundObject = selectedRows
            ?.map((b) => {
              if (a?.text?.toString() === b?.toString()) {
                return a;
              }
            })
            ?.find((obj) => obj !== undefined);

          if (foundObject !== undefined) {
            return foundObject;
          }
        })
        ?.filter((obj) => obj !== undefined);
      const thead = filteredHead;
      const tbody = d?.tbody;

      const head = [thead?.map((h) => h?.text || "") || []];
      const body =
        tbody?.map((tr, i) => {
          return (
            thead?.map((th, j) => {
              const col = tr?.find((r) => r?.theadId === th?.id);
              return col?.text || "";
            }) || []
          );
        }) || [];

      const props = {
        head: head,
        body: body,
        fileName: "Avg Transaction Value Report",
        title: "Avg Transaction Value Report",
      };
      handleDownloadPDF(props);
      setFileLoader(false);
      if(authUser){
        const logProps1 = {
          action: 'Pdf',
          event: `${pageName?.pathname?.replace("\\", " ")} page | Filters - ${combinedValues} | Pdf Clicked | Export Status: Success | Data Status: Success`
        };
        UserLog(logProps1)
      }
    } else {
      setFileLoader(false);
      if(authUser){
        const logProps1 = {
          action: 'Pdf',
          event: `${pageName?.pathname?.replace("\\", " ")} page | Filters - ${combinedValues} | Pdf Clicked | Export Status: Success | Data Status: Empty`
        };
        UserLog(logProps1)
      }
    }
    setFileLoader(false);
  };

  const getTableData = () => {
    var tableHead: Thead[] = tHead;
    var tableBody: Tbody[][] = [];

    let data =
      selection === SalesPerformanceList?.YEARLY
        ? yearlyAvgTransactionValueData
        : AvgTransactionValueData;

    data?.forEach((d, i) => {
      d?.record?.forEach((item) => {
        const brand = filteredBrand?.find(
          (f) => f?.id?.toString() === item?.brandid?.toString()
        );

        var tBody: Tbody[] = [];
        tBody?.push(
          {
            id: nanoid(),
            theadId: "Brand Name",
            children: brand?.name,
            text: brand?.name?.toString(),
          },
          {
            id: nanoid(),
            theadId: "Total Receipts",
            children: item?.total_receipts,
            text: item?.total_receipts?.toString(),
          },
          {
            id: nanoid(),
            theadId: "Total Sales",
            children: item?.total_sales,
            text: item?.total_sales?.toString(),
          },
          {
            id: nanoid(),
            theadId: "Single SKU (%)",
            children: item?.single_sku_percent,
            text: item?.single_sku_percent?.toString(),
          },
          {
            id: nanoid(),
            theadId: "Multiple SKU (%)",
            children: item?.multiple_sku_percent,
            text: item?.multiple_sku_percent?.toString(),
          },
          {
            id: nanoid(),
            theadId: "Top 10%",
            children: item?.percent_top10,
            text: item?.percent_top10?.toString(),
          },
          {
            id: nanoid(),
            theadId: "81-90%",
            children: item?.percent_81_90,
            text: item?.percent_81_90?.toString(),
          },
          {
            id: nanoid(),
            theadId: "71-80%",
            children: item?.percent_71_80,
            text: item?.percent_71_80?.toString(),
          },
          {
            id: nanoid(),
            theadId: "61-70%",
            children: item?.percent_61_70,
            text: item?.percent_61_70?.toString(),
          },
          {
            id: nanoid(),
            theadId: "51-60%",
            children: item?.percent_51_60,
            text: item?.percent_51_60?.toString(),
          },
          {
            id: nanoid(),
            theadId: "41-50%",
            children: item?.percent_41_50,
            text: item?.percent_41_50?.toString(),
          },
          {
            id: nanoid(),
            theadId: "31-40%",
            children: item?.percent_31_40,
            text: item?.percent_31_40?.toString(),
          },
          {
            id: nanoid(),
            theadId: "21-30%",
            children: item?.percent_21_30,
            text: item?.percent_21_30?.toString(),
          },
          {
            id: nanoid(),
            theadId: "11-20%",
            children: item?.percent_11_20,
            text: item?.percent_11_20?.toString(),
          },
          {
            id: nanoid(),
            theadId: "Least 10%",
            children: item?.percent_least10,
            text: item?.percent_least10?.toString(),
          }
        );
        tableBody?.push(tBody);
      });
    });
    return { tbody: tableBody, thead: tableHead };
  };

  const portfolio = useMemo<number[]>(() => {
    return portfolios !== "" ? [parseInt(portfolios)] : [];
  }, [portfolios]);
  const site = useMemo<string[]>(() => {
    if (authUserSiteId) {
      return authUserSiteId?.split(",")?.map((s) => {
        return s?.toString();
      });
    } else {
      return [];
    }
  }, [authUserSiteId]);

  const brand = useMemo<number[]>(() => {
    if (brands !== "") {
      return brands !== "" ? [parseInt(brands)] : [];
    } else return []; //bcz no brand filter
  }, [brands]);

  const category = useMemo<number[]>(() => {
    return categories !== "" ? [parseInt(categories)] : [];
  }, [categories]);

  const subCategory = useMemo<number[]>(() => {
    return subCategories !== "" ? [parseInt(subCategories)] : [];
  }, [subCategories]);

  useEffect(() => {
    setOffset(0);
  }, [yearAndMonth]);

  useEffect(() => {
    setOffset(0);
  }, [year]);


  useEffect(()=>{
    let pid =portfolioData[0] && portfolioData[0]?.id? portfolioData[0].id?.toString(): "";
    setPortfolios(selectedOption.portfolio ? selectedOption.portfolio : pid);
    const b = portfolioOption.filter((a)=>a?.id?.toString()===pid?.toString())
    if (b?.length > 0 && b[0]?.id !== undefined) {
      const val: DropDownOption = {
        value: b[0]?.id, 
        label: b[0]?.name,
        imgUrl: b[0]?.logourl, 
      };
      setPortfolioDrop([val]);
    }
},[portfolioOption,selectedOption])

  useEffect(() => {
    let sid = siteData[0] && siteData[0]?.id ? siteData[0]?.id?.toString() : "";
    setSites(selectedOption?.site ? selectedOption?.site : sid);
  }, [siteData, selectedOption]);


  useEffect(() => {
    var range = [];
    var num = Math?.ceil(length / limit);
    // let i = 1;

    for (let i = 1; i <= num; i++) {
      range?.push(i);
    }
    setRange(range);
  }, [length, limit]);



  useEffect(() => {
    if (selectedOption?.locations) setLocations(selectedOption?.locations);
  }, [selectedOption]);

  useEffect(()=>{
    setCategories(selectedOption.category ? selectedOption.category:'');
    const b = categoryOption.filter((a)=>a?.id?.toString()===selectedOption.category?.toString())
    if (b?.length > 0 && b[0]?.id !== undefined) {
      const val: DropDownOption = {
        value: b[0]?.id, 
        label: b[0]?.name,
        imgUrl:'', 
      };
      setCatDrop([val]);
    }
    },[categoryOption,selectedOption])
    
    
    useEffect(()=>{
    setSubCategories(selectedOption.subCategory ? selectedOption.subCategory:'');
    const b = subCategoryOption.filter((a)=>a?.id?.toString()===selectedOption.subCategory?.toString())
    if (b?.length > 0 && b[0]?.id !== undefined) {
      const val: DropDownOption = {
        value: b[0]?.id, 
        label: b[0]?.name,
        imgUrl:'', 
      };
      setSubcatDrop([val]);
    }
    },[subCategoryOption,selectedOption])


  useEffect(() => {
    if (sites !== ""&&selectedOption.isOutletUser===true) {
      let siteCurrencyObject = siteOption?.find(
        (s) => s?.id?.toString() === sites?.toString()
      );
      setValueIn(
        siteCurrencyObject?.currencycode +
          " | " +
          siteCurrencyObject?.valuecaption
      );
    } 
    else if(portfolios !== ""&&selectedOption.isOutletUser===false){
      let portfolioCurrencyObject = portfolioOption?.find(
        (s) => s?.id?.toString() === portfolios?.toString()
      );
      setValueIn(
        portfolioCurrencyObject?.reportingcurrency +
          " | " +
          portfolioCurrencyObject?.valuecaption
      );
    }
    else setValueIn("");
  }, [sites, siteOption,selectedOption]);


  useEffect(() => {
    if (selection === SalesPerformanceList?.MONTHLY) {
      setLength(
        AvgTransactionValueData[0]?.count
          ? AvgTransactionValueData[0]?.count
          : 0
      );
    }
    if (selection === SalesPerformanceList?.YEARLY) {
      setLength(
        yearlyAvgTransactionValueData[0]?.count
          ? yearlyAvgTransactionValueData[0]?.count
          : 0
      );
    }
  }, [selection, AvgTransactionValueData, yearlyAvgTransactionValueData]);

  useEffect(() => {
    var getData = {
      portfolio: portfolio,
    };

    if (portfolio?.length > 0 && getData !== undefined) {
      api
        .post<
          APIResponse<{ records: CatSubCatCompanyWithBrandRelationDataType[] }>
        >(`filter/catSubcatCompanyRelationWithBrand`, getData, config)
        .then((response) => {
          if (response?.status === 200 && response?.data?.data) {
            const result = response?.data?.data?.records;
            setCatSubCatCompanyWithBrandRelationData(result);
          }
        })
        .catch((error) => {});
    } else {
      setCatSubCatCompanyWithBrandRelationData([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [portfolio]);

  const colors = [
    COLORS?.COLOR1,
    COLORS?.COLOR2,
    COLORS?.COLOR3,
    COLORS?.COLOR4,
    COLORS?.COLOR5,
    COLORS?.COLOR6,
    COLORS?.COLOR7,
    COLORS?.COLOR8,
  ];

  const handlePag = () => {
    setPag(true);
  };

  return (
    <UserLayout>
      <div className="card background-transparent p-1">
        <div className="row">
          <div
            className="col-lg-4 wow fadeInLeft ps-0"
            // style="visibility: visible; animation-name: fadeInLeft;"
          >
            <h4 className="b-title">Average Transaction Value</h4>
          </div>

          <div className="col-lg-8 wow fadeInRight">
            <div className="row">
              <div className="col-sm-3 col-md-3 col-lg-3">
                {/* <FormInput2
                  name="Portfolio"
                  label=""
                  labelClassName="required"
                  value={portfolios}
                  onChange={handlePortfolioChange}
                  placeholder="Select"
                  containerClass="mb-1"
                  type="select"
                >
                  <option value="">Select</option>
                  {portfolioData?.map((p, i) => {
                    return (
                      <Option value={p?.id} key={i}>
                        {p?.name}
                      </Option>
                    );
                  })}
                </FormInput2> */}
                   {/* <SingleSelect
                  options={[
                    defaultPortfolio,
                    ...portfolioData?.sort(function (a, b) {
                      if (a?.name < b?.name) {
                        return -1;
                      }
                      if (a?.name > b?.name) {
                        return 1;
                      }
                      return 0;
                    })?.map((s, i) => {
                      return (
                        {
                          value: s?.id ? s?.id?.toString() : '',
                          label: s?.name,
                          imgUrl: s?.logourl,
                        }
                      );
                    })
                  ]}
                  label=""
                  selectedOptions={portfoliosOption}
                  setSelectedOptions={handlePortfolioChange}
                  // disabled={disableSite}
                  disabled={disableLocality}
                  placeHolder="Select Portfolio"
                  // filterText=""
                /> */}
                 <SingleSelect1
                      options={portfolioData.map((c, i) => {
                        return {
                          value: c?.id?c?.id:0,
                          label: c?.name?c?.name:'',
                          imgUrl: "",
                        };
                      })}
                      selectedOptions={portfolioDrop}
                      setSelectedOptions={handlePortfolioDrop}
                      placeHolder="Select Portfolio"
                      onClear={handleClearPortfolio}
                      disabled = {disableLocality}
                    />
              </div>
              <div className="col-sm-3 col-md-3 col-lg-3">
              <MultiSelect
                  options={localityOption?.map((sc) => {
                    return {
                      value: sc?.id ? sc?.id : 0,
                      label: sc?.area?.toString(),
                      imgUrl: "",
                    };
                  })}
                  label=""
                  selectedOptions={locations}
                  setSelectedOptions={setLocations}
                  disabled={disableLocality}
                  placeHolder="All Locality"
                /> 
              {/* <FormInput2
                  name="Location"
                  label=""
                  labelClassName="required"
                  value={location}
                  onChange={handleLocationChange}
                  placeholder="Select Locality"
                  containerClass="mb-1"
                  disabled={disableLocality}
                  type="select"
                >
                  <option value="">Select Locality</option>
                  {localityOption?.map((s, i) => {
                    return (
                      <Option value={s?.area} key={i}>
                        {s?.area}
                      </Option>
                    );
                  })}
                </FormInput2> */}
              </div>
              <div className="col-sm-3 col-md-3 col-lg-3">
                {/* <FormInput2
                  name="Trade Category"
                  label=""
                  labelClassName="required"
                  value={categories}
                  onChange={handleCategoryChange}
                  placeholder="Select Trade Category"
                  containerClass="mb-1"
                  type="select"
                >
                  <option value="">Select Trade Category</option>
                  {categoryOption?.map((s, i) => {
                    return (
                      <Option value={s?.id} key={i}>
                        {s?.name}
                      </Option>
                    );
                  })}
                </FormInput2> */}
                     {/* <SingleSelect
                  options={[
                    defaultTradeCategory,
                    ...categoryOption?.sort(function (a, b) {
                      if (a?.name < b?.name) {
                        return -1;
                      }
                      if (a?.name > b?.name) {
                        return 1;
                      }
                      return 0;
                    })?.map((s, i) => {
                      return (
                        {
                          value: s?.id ? s?.id?.toString() : '',
                          label: s?.name,
                          imgUrl: '',
                        }
                      );
                    })
                  ]}
                  label=""
                  selectedOptions={categoriesOption}
                  setSelectedOptions={handleCategoryChange}
                  // disabled={disableSite}
                  disabled={disableLocality}
                  placeHolder="Select Trade Category"
                  // filterText=""
                /> */}
                <SingleSelect1
                      options={categoryOption.map((c, i) => {
                        return {
                          value: c?.id?c?.id:0,
                          label: c?.name?c?.name:'',
                          imgUrl: "",
                        };
                      })}
                      selectedOptions={catDrop}
                      setSelectedOptions={handleCatDrop}
                      placeHolder="Select Trade Category"
                      onClear={handleClearCat}
                      disabled = {disableLocality}
                    />
              </div>
              <div className="col-sm-3 col-md-3 col-lg-3">
                {/* <FormInput2
                  name="Trade Sub Category"
                  label=""
                  labelClassName="required"
                  value={subCategories}
                  onChange={handleSubCategoryChange}
                  placeholder="Select Trade Sub Category"
                  containerClass="mb-1"
                  type="select"
                >
                  <option value="">Select Trade Sub Category</option>
                  {subCategoryFilteredByCategory?.map((s, i) => {
                    return (
                      <Option value={s?.id} key={i}>
                        {s?.name}
                      </Option>
                    );
                  })}
                </FormInput2> */}
                 {/* <SingleSelect
                  options={[
                    defaultTradeSubCategory,
                    ...subCategoryFilteredByCategory?.sort(function (a, b) {
                      if (a?.name < b?.name) {
                        return -1;
                      }
                      if (a?.name > b?.name) {
                        return 1;
                      }
                      return 0;
                    })?.map((s, i) => {
                      return (
                        {
                          value: s?.id ? s?.id?.toString() : '',
                          label: s?.name,
                          imgUrl: '',
                        }
                      );
                    })
                  ]}
                  label=""
                  selectedOptions={subCategoriesOption}
                  setSelectedOptions={handleSubCategoryChange}
                  // disabled={disableSite}
                  disabled={disableLocality}
                  placeHolder="Select Trade Sub Category"
                  // filterText=""
                /> */}
                 <SingleSelect1
                      options={subCategoryFilteredByCategory.map((c, i) => {
                        return {
                          value: c?.id?c?.id:0,
                          label: c?.name?c?.name:'',
                          imgUrl: "",
                        };
                      })}
                      selectedOptions={subcatDrop}
                      setSelectedOptions={handleSubcatDrop}
                      placeHolder="Select Trade Sub Category"
                      onClear={handleClearSubcat}
                      disabled = {disableLocality}
                    />
              </div>
            </div>

            {/* <div className="row mt-1">
              
              
            </div> */}
          </div>
        </div>
      </div>

      {loader ? (
        <Loader />
      ) : (
        <>
          <div className="row">
            <div className="col-12">
              <div className="card mt-3 widget_div" onMouseEnter={() => setButtonVisible(true)} onMouseLeave={() => setButtonVisible(false)}>
                {(<button type="button" className="expandIconBtn" onClick={showExpandModalHandler} ><i><FontAwesomeIcon icon={faWindowMaximize} size="lg" title="Open in Popup"/></i></button>)}
                <div className="card-body">
                  <div className="row mb-1">
                    <div className="col-lg-6 col-sm-12">
                      <div className="float-start">
                        <h5 className="header-title mt-1">
                          <img src={chartIcon} alt="icon"></img> Average
                          Transaction Value
                        </h5>
                      </div>
                    </div>
                    <div className="col-lg-6 col-sm-12">
                      <div className="float-end hstack gap-1">
                        
                        {selection === SalesPerformanceList?.MONTHLY && (
                          <div
                            className="col-sm-6 col-md-6 col-lg-6"
                            style={{ width: "133px" }}
                          >
                            <div className="DateContainer">
                              <span className="dateInput">
                                <ReactDatePicker
                                  id="DatePicker"
                                  // type="string"
                                  className="text-center fw-bold form-control"
                                  selected={yearAndMonth}
                                  onChange={(date: any) =>
                                    setYearAndMonth(date)
                                  }
                                  showMonthYearPicker
                                  dateFormat="MM/yyyy"
                                  yearItemNumber={8}
                                  //     required
                                />
                              </span>
                              <span className="icon">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M14.25 2.6001C14.4709 2.6001 14.65 2.77918 14.65 3.0001V4.26685H16.125C16.7141 4.26685 17.2873 4.47445 17.7165 4.85604C18.1474 5.23898 18.4 5.76918 18.4 6.33351V9.66685V16.3335C18.4 16.8979 18.1474 17.428 17.7165 17.811C17.2873 18.1926 16.7141 18.4002 16.125 18.4002H4.87498C4.28582 18.4002 3.71269 18.1926 3.2834 17.811C2.85259 17.428 2.59998 16.8978 2.59998 16.3335V9.66685V6.33351C2.59998 5.76918 2.85259 5.23898 3.2834 4.85604C3.71269 4.47445 4.28582 4.26685 4.87498 4.26685H6.34998V3.0001C6.34998 2.77918 6.52906 2.6001 6.74998 2.6001C6.97089 2.6001 7.14998 2.77918 7.14998 3.0001V4.26685H13.85V3.0001C13.85 2.77918 14.0291 2.6001 14.25 2.6001ZM17.6 6.33351V9.26685H3.39998V6.33351C3.39998 6.01379 3.54245 5.69614 3.8149 5.45396C4.08888 5.21043 4.46957 5.06685 4.87498 5.06685H6.34998V6.33343C6.34998 6.55434 6.52906 6.73343 6.74998 6.73343C6.97089 6.73343 7.14998 6.55434 7.14998 6.33343V5.06685H13.85V6.33343C13.85 6.55434 14.0291 6.73343 14.25 6.73343C14.4709 6.73343 14.65 6.55434 14.65 6.33343V5.06685H16.125C16.5304 5.06685 16.9111 5.21043 17.1851 5.45396C17.4575 5.69614 17.6 6.01379 17.6 6.33351ZM17.6 10.0668H3.39998V16.3335C3.39998 16.6532 3.54245 16.9709 3.8149 17.2131C4.08888 17.4566 4.46957 17.6002 4.87498 17.6002H16.125C16.5304 17.6002 16.9111 17.4566 17.1851 17.2131C17.4575 16.9709 17.6 16.6532 17.6 16.3335V10.0668ZM10.5 12.6001C10.1595 12.6001 9.82478 12.7199 9.57132 12.9452C9.31632 13.1719 9.16248 13.4901 9.16248 13.8334C9.16248 14.1768 9.31632 14.495 9.57132 14.7217C9.82478 14.947 10.1595 15.0668 10.5 15.0668C10.8405 15.0668 11.1752 14.947 11.4286 14.7217C11.6836 14.495 11.8375 14.1768 11.8375 13.8334C11.8375 13.4901 11.6836 13.1719 11.4286 12.9452C11.1752 12.7199 10.8405 12.6001 10.5 12.6001ZM10.1028 13.5431C10.201 13.4559 10.3432 13.4001 10.5 13.4001C10.6567 13.4001 10.799 13.4559 10.8971 13.5431C10.9938 13.629 11.0375 13.7347 11.0375 13.8334C11.0375 13.9321 10.9938 14.0378 10.8971 14.1237C10.799 14.211 10.6567 14.2668 10.5 14.2668C10.3432 14.2668 10.201 14.211 10.1028 14.1237C10.0062 14.0378 9.96248 13.9321 9.96248 13.8334C9.96248 13.7347 10.0062 13.629 10.1028 13.5431Z"
                                    fill="#6C757D"
                                  ></path>
                                </svg>
                              </span>
                            </div>
                          </div>
                        )}
                        {selection === SalesPerformanceList.YEARLY && (
                          <div
                            className="col-sm-6 col-md-6 col-lg-6"
                            style={{ width: "133px" }}
                          >
                            <div className="DateContainer">
                              <span className="dateInput">
                                <ReactDatePicker
                                  id="DatePicker"
                                  // type="string"
                                  className="text-center fw-bold form-control"
                                  selected={year}
                                  onChange={(date: any) => setYear(date)}
                                  showYearPicker
                                  dateFormat="yyyy"
                                  yearItemNumber={8}
                                  //     required
                                />
                              </span>
                              <span className="icon">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M14.25 2.6001C14.4709 2.6001 14.65 2.77918 14.65 3.0001V4.26685H16.125C16.7141 4.26685 17.2873 4.47445 17.7165 4.85604C18.1474 5.23898 18.4 5.76918 18.4 6.33351V9.66685V16.3335C18.4 16.8979 18.1474 17.428 17.7165 17.811C17.2873 18.1926 16.7141 18.4002 16.125 18.4002H4.87498C4.28582 18.4002 3.71269 18.1926 3.2834 17.811C2.85259 17.428 2.59998 16.8978 2.59998 16.3335V9.66685V6.33351C2.59998 5.76918 2.85259 5.23898 3.2834 4.85604C3.71269 4.47445 4.28582 4.26685 4.87498 4.26685H6.34998V3.0001C6.34998 2.77918 6.52906 2.6001 6.74998 2.6001C6.97089 2.6001 7.14998 2.77918 7.14998 3.0001V4.26685H13.85V3.0001C13.85 2.77918 14.0291 2.6001 14.25 2.6001ZM17.6 6.33351V9.26685H3.39998V6.33351C3.39998 6.01379 3.54245 5.69614 3.8149 5.45396C4.08888 5.21043 4.46957 5.06685 4.87498 5.06685H6.34998V6.33343C6.34998 6.55434 6.52906 6.73343 6.74998 6.73343C6.97089 6.73343 7.14998 6.55434 7.14998 6.33343V5.06685H13.85V6.33343C13.85 6.55434 14.0291 6.73343 14.25 6.73343C14.4709 6.73343 14.65 6.55434 14.65 6.33343V5.06685H16.125C16.5304 5.06685 16.9111 5.21043 17.1851 5.45396C17.4575 5.69614 17.6 6.01379 17.6 6.33351ZM17.6 10.0668H3.39998V16.3335C3.39998 16.6532 3.54245 16.9709 3.8149 17.2131C4.08888 17.4566 4.46957 17.6002 4.87498 17.6002H16.125C16.5304 17.6002 16.9111 17.4566 17.1851 17.2131C17.4575 16.9709 17.6 16.6532 17.6 16.3335V10.0668ZM10.5 12.6001C10.1595 12.6001 9.82478 12.7199 9.57132 12.9452C9.31632 13.1719 9.16248 13.4901 9.16248 13.8334C9.16248 14.1768 9.31632 14.495 9.57132 14.7217C9.82478 14.947 10.1595 15.0668 10.5 15.0668C10.8405 15.0668 11.1752 14.947 11.4286 14.7217C11.6836 14.495 11.8375 14.1768 11.8375 13.8334C11.8375 13.4901 11.6836 13.1719 11.4286 12.9452C11.1752 12.7199 10.8405 12.6001 10.5 12.6001ZM10.1028 13.5431C10.201 13.4559 10.3432 13.4001 10.5 13.4001C10.6567 13.4001 10.799 13.4559 10.8971 13.5431C10.9938 13.629 11.0375 13.7347 11.0375 13.8334C11.0375 13.9321 10.9938 14.0378 10.8971 14.1237C10.799 14.211 10.6567 14.2668 10.5 14.2668C10.3432 14.2668 10.201 14.211 10.1028 14.1237C10.0062 14.0378 9.96248 13.9321 9.96248 13.8334C9.96248 13.7347 10.0062 13.629 10.1028 13.5431Z"
                                    fill="#6C757D"
                                  ></path>
                                </svg>
                              </span>
                            </div>
                          </div>
                        )}
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleApply}
                          >
                            Apply
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr className="m-0 my-2 p-0 hr" />
                  {AvgTransactionValueData[0]?.record?.length > 0 &&
                    AvgTransactionValueData[0]?.record[0] !== undefined &&
                    selection === SalesPerformanceList?.MONTHLY && (
                      <div>{"*Value in " + valueIn}</div>
                    )}

                  {yearlyAvgTransactionValueData[0]?.record?.length > 0 &&
                    yearlyAvgTransactionValueData[0]?.record[0] !== undefined &&
                    selection === SalesPerformanceList?.YEARLY && (
                      <div>{"*Value in " + valueIn}</div>
                    )}

                  <div className="col-lg-12 col-sm-12 text-end">
                    {/* <div className="float-end"> */}
                    <button
                      type="button"
                      onClick={monthlyHandler}
                      className={`m-1 btn btn-xs ${
                        selection === "monthly"
                          ? "btn-primary"
                          : "btn-secondary"
                      }`}
                    >
                      Monthly
                    </button>

                    <button
                      type="button"
                      onClick={yearlyHandler}
                      className={`m-1 btn btn-xs ${
                        selection === "yearly" ? "btn-primary" : "btn-secondary"
                      }`}
                    >
                      Yearly
                    </button>

                    {/* </div> */}
                  </div>

                  {selection === SalesPerformanceList?.MONTHLY &&
                    (AvgTransactionValueData[0]?.record?.length !== undefined &&
                    AvgTransactionValueData[0]?.record?.length > 0 ? (
                      <AvtMonthly 
                        AvgTransactionValueData={AvgTransactionValueData}
                        yearAndMonth={yearAndMonth}
                        getSubtitle={getSubtitle}
                        filteredBrand={filteredBrand}
                      />
                    ) : (
                      <div className="d-flex flex-column justify-content-center align-items-center col-12 emptychart-container  ">
                        <p className="empty-data">No Records Found</p>
                      </div>
                    ))}

                  {selection === SalesPerformanceList?.YEARLY &&
                    (yearlyAvgTransactionValueData[0]?.record?.length !==
                      undefined &&
                    yearlyAvgTransactionValueData[0]?.record?.length > 0 ? (
                      <AvtYearly 
                        yearlyAvgTransactionValueData={yearlyAvgTransactionValueData}
                        year={year}
                        getSubtitle={getSubtitle}
                        filteredBrand={filteredBrand}
                      />
                    ) : (
                      <div className="d-flex flex-column justify-content-center align-items-center col-12 emptychart-container  ">
                        <p className="empty-data">No Records Found</p>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="card mt-3">
                <div className="card-body">
                  <div className="row mb-1">
                    <div className="col-lg-6 col-sm-12">
                      <div className="float-start">
                        <h5 className="header-title mt-1">
                          <img src={tableIcon} alt="icon"></img>
                          {selection === SalesPerformanceList?.YEARLY
                            ? "Yearly"
                            : "Monthly"}{" "}
                          Average Transaction Value
                        </h5>
                      </div>
                    </div>
                    <div className="col-lg-6 col-sm-12">
                      <div className="float-end hstack gap-1">
                        {/* <input type='date' className="form-control" /> */}
                        {/* <input type='date' className="form-control" /> */}
                        {/* <div className='col-sm-6 col-md-6 col-lg-6' style={{ width: '133px' }}>
                                            <FormInput
                                                name='From Date'
                                                label=''
                                                labelClassName="required"
                                                value={fromDate}
                                                onChange={handleFromDate}
                                                type='date'
                                                placeholder='From Date'
                                            // errorText={shortcodeError}
                                            // containerClass="mb-2"
                                            // disabled={showViewForm}
                                            />
                                        </div>
                                        <div className='col-sm-6 col-md-6 col-lg-6' style={{ width: '133px' }}>
                                            <FormInput
                                                name='To Date'
                                                label=''
                                                labelClassName="required"
                                                value={toDate}
                                                onChange={handleToDate}
                                                type='date'
                                                placeholder='To Date'
                                            // errorText={shortcodeError}
                                            // containerClass="mb-2"
                                            // disabled={showViewForm}
                                            />
                                        </div> */}
                      </div>
                    </div>
                  </div>

                  {selection === SalesPerformanceList?.MONTHLY && (
                    <TransactionTable
                      data={[]}
                      {...getTableData()}
                      title=""
                      downloadCSV={true}
                      downloadPDF={true}
                      fileName="Average Transaction Value"
                      limit={limit}
                      setOffset={setOffset}
                      onClickCSV={handleCsvDownload}
                      onClickPDF={handlePdfDownload}
                      range={range}
                      valueInString={valueIn}
                      
                      fLoader={fileLoader}
                      onPageNoChange={pag && (offset > 0||condition) ? handleApply : undefined}
                      handlePag={pag ? handlePag : undefined}
                      onOffchange={handleOff}
                      onSelectedRowsChange={handleSelectedRowsChange}
                    />
                  )}
                  {selection === SalesPerformanceList?.YEARLY && (
                    <TransactionTable
                      data={[]}
                      {...getTableData()}
                      title=""
                      downloadCSV={true}
                      downloadPDF={true}
                      fileName="Average Transaction Value"
                      limit={limit}
                      setOffset={setOffset}
                      onClickCSV={handleCsvDownload}
                      onClickPDF={handlePdfDownload}
                      range={range}
                      valueInString={valueIn}
                      onPageNoChange={pag && (offset > 0||condition) ? handleApply : undefined}
                      handlePag={pag ? handlePag : undefined}
                      onOffchange={handleOff}
                      fLoader={fileLoader}
                   
                      onSelectedRowsChange={handleSelectedRowsChange}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>

          {showModal && (
        <Modal
        headerText={"Average Transaction Value"}
        visible={showModal}
        onClose={() => setShowModal(false)}
        size="xl"
        centered
        classname="widget-container-single" > 
		
    <div className="card-body">
                  {selection === SalesPerformanceList?.MONTHLY &&
                    (AvgTransactionValueData[0]?.record?.length !== undefined &&
                    AvgTransactionValueData[0]?.record?.length > 0 ? (
                      <AvtMonthly 
                        AvgTransactionValueData={AvgTransactionValueData}
                        yearAndMonth={yearAndMonth}
                        getSubtitle={getSubtitle}
                        filteredBrand={filteredBrand}
                      />
                    ) : (
                      <div className="d-flex flex-column justify-content-center align-items-center col-12 emptychart-container  ">
                        <p className="empty-data">No Records Found</p>
                      </div>
                    ))}

                  {selection === SalesPerformanceList?.YEARLY &&
                    (yearlyAvgTransactionValueData[0]?.record?.length !==
                      undefined &&
                    yearlyAvgTransactionValueData[0]?.record?.length > 0 ? (
                      <AvtYearly 
                        yearlyAvgTransactionValueData={yearlyAvgTransactionValueData}
                        year={year}
                        getSubtitle={getSubtitle}
                        filteredBrand={filteredBrand}
                      />
                    ) : (
                      <div className="d-flex flex-column justify-content-center align-items-center col-12 emptychart-container  ">
                        <p className="empty-data">No Records Found</p>
                      </div>
                    ))}
                </div>
		
		</Modal>)}
        </>
      )}
    </UserLayout>
  );
};
export default SalesAvgTransactionValueReport;
